import React from 'react';
import SparkMD5 from 'spark-md5';
import Avatar from './Avatar.jsx';
import withFormContainer from './withFormContainer.jsx';

import { defaultApp } from '../utils/firebase';

import './UserProfileForm.css';

class UserProfileForm extends React.Component {

    state = {
        displayName: this.props.userDisplayName,
        photoURL: this.props.userPhotoURL,
        dangerZoneIsShowing: false,
        dangerZoneValue: '',
        error: ''
    };

    componentDidUpdate() {
        this.props.sendResizeEvent();
    }

    onChangeDisplayName = ({ currentTarget: { value: displayName } }) => {

        this.setState({ displayName });
    };

    onChangePhotoURL = ({ currentTarget: { value: photoURL } }) => {

        this.setState({ photoURL });
    };

    onSubmit = e => {

        e.preventDefault();

        this.props.changeLoading(true)
            .then(() => this.props.updateUserProfile(this.state.displayName, this.state.photoURL))
            .then(() => this.props.close({ currentTarget: { value: this.props.closeValue } }))
            .catch(() => this.props.changeLoading(false))

    };

    onLogout = e => {

        this.props.changeLoading(true).then(() => this.props.onLogout());
    };

    onChangeDangerZoneValue = ({ currentTarget: { value: dangerZoneValue } }) => {

        this.setState({ dangerZoneValue });
    };

    onChangeDangerZoneIsShowing = e => {

        this.setState({
            dangerZoneIsShowing: !this.state.dangerZoneIsShowing
        });
    };

    onDeleteEverything = e => {

        e.preventDefault();

        return defaultApp.auth().currentUser.delete().catch(({ message: error }) => {

            this.setState({ error });
        });
    };

    onSyncWithSingleSignOn = e => {

        this.setState({
            displayName: this.props.ssoDisplayName,
            photoURL: this.props.ssoPhotoURL
        });
    };

    get photoSources() {

        const hash = SparkMD5.hash(defaultApp.auth().currentUser.email.toLowerCase().trim());

        const gravatar = `https://www.gravatar.com/avatar/${hash}.jpg?d=identicon`;
        const providerData = this.props.userProviderData.filter(({ providerId }) => providerId !== 'password');

        if (this.props.sso && this.props.ssoPhotoURL) {
            providerData.push({
                providerId: this.props.ssoText,
                photoURL: this.props.ssoPhotoURL
            });
        }

        return providerData.map(({ providerId, photoURL }) => {

                return (
                    <div key={providerId}>
                        <label className="avatar-option option clearfix">
                            <div className="radio">
                                <input
                                    type="radio"
                                    name="avatar_source"
                                    value={photoURL}
                                    checked={this.state.photoURL === photoURL}
                                    onChange={this.onChangePhotoURL}
                                />
                            </div>
                            <Avatar image={photoURL} />
                            <span>{providerId}</span>
                        </label>
                    </div>
                );
            })
            .concat([
                <div key="gravatar">
                    <label className="avatar-option option clearfix">
                        <div className="radio">
                            <input
                                type="radio"
                                name="avatar_source"
                                value={gravatar}
                                checked={this.state.photoURL === gravatar}
                                onChange={this.onChangePhotoURL}
                            />
                        </div>
                        <Avatar image={gravatar} />
                        <span>Gravatar</span>
                    </label>
                </div>,
                <div key="none">
                    <label className="avatar-option option clearfix">
                        <div className="radio">
                            <input
                                type="radio"
                                name="avatar_source"
                                value={''}
                                checked={!this.state.photoURL}
                                onChange={this.onChangePhotoURL}
                            />
                        </div>
                        <Avatar />
                        <span>none</span>
                    </label>
                </div>
            ]);
    }

    get dangerZone() {

        if (!this.state.dangerZoneIsShowing) {
            return null;
        }

        return (
            <div className="danger-zone">
                <form onSubmit={this.onDeleteEverything}>

                    <div className="form-group">
                        <label htmlFor="delete-everything">
                            Account Removal
                        </label>
                        <p>
                            Warning: all your data (including account, comments, etc.) will be deleted. This action is <strong>irreversible</strong>.
                        </p>
                        {this.state.error ? (
                            <p className="error">
                                {this.state.error}
                            </p>
                        ) : null}
                        <input
                            type="text"
                            className="form-control"
                            id="delete-everything"
                            placeholder={`Type "DELETE EVERYTHING" to confirm`}
                            value={this.state.dangerZoneValue}
                            onChange={this.onChangeDangerZoneValue}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <button
                            type="submit"
                            className="btn danger-button"
                            disabled={this.state.dangerZoneValue !== 'DELETE EVERYTHING'}
                        >
                            Delete Everything
                        </button>
                        <button
                            type="button"
                            className="btn secondary-button"
                            onClick={this.onChangeDangerZoneIsShowing}
                        >
                            Cancel
                        </button>
                    </div>

                </form>
            </div>
        );
    }

    get ssoOptions() {

        if (!this.props.sso || !this.props.ssoDisplayName) {
            return null;
        }

        return (
            <div className="form-group">

                <button
                    className="btn secondary-button"
                    type="button"
                    onClick={this.onSyncWithSingleSignOn}
                >
                    Sync with {this.props.ssoText}
                </button>

            </div>
        );
    }

    render() {

        return (
            <div className="settings user-profile-form">

                <h3 className="form-container-header">Profile</h3>

                <form onSubmit={this.onSubmit}>

                    {this.ssoOptions}

                    <div className="form-group">

                        <fieldset>
                            <legend>Avatar</legend>
                            {this.photoSources}
                        </fieldset>

                    </div>

                    <div className="form-group">

                        <label htmlFor="display-name" className="header">Display Name</label>
                        <input
                            type="text"
                            id="display-name"
                            value={this.state.displayName}
                            onChange={this.onChangeDisplayName}
                            required
                        />

                    </div>

                    <div className="form-group">
                        <button
                            disabled={this.state.displayName.length === 0 || this.props.loading}
                            className="btn primary-button"
                            type="submit"
                        >
                            Update
                        </button>

                        <button
                            className="btn secondary-button"
                            type="button"
                            onClick={this.props.close}
                            value={this.props.closeValue}
                        >
                            Cancel
                        </button>

                        <button className="btn open-danger-zone" type="button" onClick={this.onChangeDangerZoneIsShowing}>
                            danger zone {this.state.dangerZoneIsShowing ? '-' : '+'}
                        </button>

                    </div>

                </form>

                {this.dangerZone}

            </div>
        );
    }
}

export default withFormContainer(UserProfileForm);


// WEBPACK FOOTER //
// ./src/components/UserProfileForm.jsx